import React, { useCallback, useEffect, useRef } from "react";
import Input from "../../DesignSystem/input";
import FormFieldBox from "../../DesignSystem/formFieldBox";
import { RequestQuoteFieldsMapping, ErrorMessages } from "../../../utils/appConstants";

interface RegistrationFormProps {
  onFieldChange: (fieldName: string, value: string) => void;
  onEmailBlur: (_: any) => void;
  emailError: string;
  scrollToTop: boolean;
  onKeypress: (e: any) => void;
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({ onKeypress, onFieldChange, onEmailBlur, emailError, scrollToTop }) => {
  const ref = useRef(null);

  const handleInputChange = useCallback(
    (field: string, e: any) => {
      onFieldChange(field, e?.target?.value?.trim() ?? "");
    },
    [onFieldChange]
  );

  useEffect(() => {
    if (scrollToTop) {
      // @ts-ignore
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [scrollToTop, ref]);

  return (
    <form className="form request-quote" name="registration-form">
      <div className="two-form-fields-div">
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              First Name<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.fname}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.fname, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              Last Name<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.lname}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.lname, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
      </div>
      <div className="two-form-fields-div">
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              Company<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.company}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.company, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              Title<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.title}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.title, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
      </div>
      <FormFieldBox>
        <label>
          Email<span className="asterisk">*</span>
        </label>
        <Input
          name={RequestQuoteFieldsMapping.email}
          variant="input"
          onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.email, e)}
          error={!!emailError}
          errorMessage={emailError || ""}
          onBlur={onEmailBlur}
          onKeypress={onKeypress}
        />
      </FormFieldBox>
      <FormFieldBox>
        <label>
          Contact No.<span className="asterisk">*</span>
        </label>
        <Input
          variant="input"
          name={RequestQuoteFieldsMapping.contact}
          onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.contact, e)}
          onKeypress={onKeypress}
        />
      </FormFieldBox>
      <FormFieldBox>
        <label>
          Address<span className="asterisk">*</span>
        </label>
        <Input
          variant="input"
          name={RequestQuoteFieldsMapping.address}
          onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.address, e)}
          onKeypress={onKeypress}
        />
        <span style={{ paddingBottom: "3px" }} />
        <Input
          variant="input"
          name={RequestQuoteFieldsMapping.address2}
          onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.address2, e)}
          onKeypress={onKeypress}
        />
      </FormFieldBox>
      <div className="two-form-fields-div">
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              Country<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.country}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.country, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              State<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.state}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.state, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
      </div>
      <div className="two-form-fields-div">
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              City<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.city}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.city, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
        <div className="one-form-field-div">
          <FormFieldBox>
            <label>
              Zip<span className="asterisk">*</span>
            </label>
            <Input
              variant="input"
              name={RequestQuoteFieldsMapping.zip}
              onChange={(e) => handleInputChange(RequestQuoteFieldsMapping.zip, e)}
              onKeypress={onKeypress}
            />
          </FormFieldBox>
        </div>
      </div>
    </form>
  );
};

export default RegistrationForm;
